export default "__VITE_ASSET__Coxjhpdq__"